


































import Vue from 'vue'

export default Vue.extend({
  name: 'ReportAbuseDialog',
  props: {
    value: {
      type: Boolean,
    },
    sendReportLoading: {
      type: Boolean,
    },
  },
  data: () => ({
    description: '',
    descriptionRules: [
      (v: string) => !!v || "Describe the problem can't be empty.",
    ],
  }),
  methods: {
    init: function () {
      this.description = ''
      ;(this.$refs.reportAbuseFormRef as any).resetValidation()
    },
    sendReport: function () {
      this.$emit('reportAbuse', this.description)
      this.init()
    },
  },
})
